const baseUrlPrice = '/price';
const baseUrlMeter = '/meter';
const baseUrlProduct = '/product';
const baseUrlSubscription = '/subscription';
const baseUrlInvoice = '/invoice';
const baseUrlCoupon = '/coupon';
// Redemptions sit on their own route, not under /coupon: a literal segment outranks a route
// parameter, so /coupon/redemption would shadow the code lookup at /coupon/{code}.
const baseUrlCouponRedemption = '/couponredemption';
export const stripeRoutes = {
  meter: "".concat(baseUrlMeter, "/types"),
  invoice: "".concat(baseUrlInvoice),
  invoiceUpcoming: "".concat(baseUrlInvoice, "/upcoming"),
  coupon: "".concat(baseUrlCoupon),
  couponByCode: code => "".concat(baseUrlCoupon, "/").concat(code),
  couponById: id => "".concat(baseUrlCoupon, "/").concat(id),
  couponRedemption: "".concat(baseUrlCouponRedemption),
  couponRedemptionById: id => "".concat(baseUrlCouponRedemption, "/").concat(id),
  couponRedemptionsByCoupon: couponId => "".concat(baseUrlCouponRedemption, "/coupon/").concat(couponId),
  product: "".concat(baseUrlProduct),
  productById: id => "".concat(baseUrlProduct, "/").concat(id),
  subscription: "".concat(baseUrlSubscription),
  updateSubscription: subscriptionId => "".concat(baseUrlSubscription, "/").concat(subscriptionId),
  subscriptionDashboard: "".concat(baseUrlSubscription, "/dashboard"),
  subscriptionCompany: "".concat(baseUrlSubscription, "/company"),
  bulkUpdateSubscription: "".concat(baseUrlSubscription, "/bulk-update"),
  scheduleChangeEstimate: subscriptionId => "".concat(baseUrlSubscription, "/").concat(subscriptionId, "/schedule/estimate"),
  scheduleChange: subscriptionId => "".concat(baseUrlSubscription, "/").concat(subscriptionId, "/schedule"),
  rescheduleChange: (subscriptionId, changeId) => "".concat(baseUrlSubscription, "/").concat(subscriptionId, "/schedule/").concat(changeId),
  removeScheduledChange: (subscriptionId, changeId) => "".concat(baseUrlSubscription, "/").concat(subscriptionId, "/schedule/").concat(changeId),
  price: "".concat(baseUrlPrice),
  detachPrice: "".concat(baseUrlPrice, "/detach"),
  priceDashboard: "".concat(baseUrlPrice, "/dashboard"),
  subscriptionTemplates: "".concat(baseUrlPrice, "/subscription-templates"),
  actionPriceById: id => "".concat(baseUrlPrice, "/").concat(id),
  bulkDelete: "".concat(baseUrlPrice, "/bulk-delete"),
  detachPriceFromSubscription: "".concat(baseUrlPrice, "/detach")
};